import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../utilities/constants";
import PaginatedDropdown, { mapOptions } from "../../components/ui/PaginatedDropDown";


const TableFilter = ({ onStylistChange, type }) => {
  const [selectedStylist, setSelectedStylist] = useState(type || null);

   useEffect(() => {
     setSelectedStylist();
      onStylistChange?.(type?.value);
  }, []);


  const labelStylistTypeFunc = (o) =>`${o.displayName}`;
  return (
    <div className="flex flex-col md:flex-row md:items-end gap-3">
      <div className="flex flex-col w-full md:w-64">
        <div className=" px-2">
          <PaginatedDropdown
            searchkey="keyword"
            datakey="data"
            selectedValue={selectedStylist}
            url={`${API_BASE_URL}/api/1.0.0/aistylist/v2/stylists?type=VIRTUAL&`}
            mapOptions={(records) =>
              mapOptions(records, "id", labelStylistTypeFunc)
            }
            placeHolder="Select Stylist"
            onChange={(v) => {
              console.log("VVVV",v);
              // handleQueryParamChange("id", v?.value);
              setSelectedStylist(v);
              onStylistChange?.(v?.value);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TableFilter;
